<template>
  <UDropdownMenu
    :items="menuItems"
    :content="{ align: 'end', side: 'bottom' }"
  >
    <button
      type="button"
      aria-haspopup="menu"
      class="flex items-center gap-2 rounded-lg border border-[var(--ui-border)] px-2 py-1.5 text-start transition hover:bg-[var(--ui-bg-elevated)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
      :class="collapsed ? 'justify-center' : 'w-full justify-between'"
    >
      <UUser
        :name="collapsed ? undefined : (user?.name ?? 'کاربر آراد')"
        :description="collapsed ? undefined : toFaDigits(user?.phone ?? '')"
        :avatar="avatarProps"
        size="sm"
        :ui="{ root: 'min-w-0' }"
      />
      <UIcon
        v-if="!collapsed"
        name="i-lucide-chevron-down"
        class="size-4 shrink-0 text-[var(--ui-text-muted)]"
      />
    </button>
  </UDropdownMenu>
</template>

<script setup lang="ts">
import { useAuthStore } from '~/stores/useAuthStore'
import { toFaDigits } from '~/utils/faDigits'
import { isDashboardPathAllowed } from '~/utils/practice/roles'

defineProps<{
  collapsed?: boolean
}>()

const auth = useAuthStore()
const user = computed(() => auth.user)

const avatarProps = computed(() => ({
  alt: user.value?.name ?? 'کاربر آراد',
  src: user.value?.avatar,
  icon: 'i-lucide-user',
}))

const menuItems = computed(() => {
  const role = auth.user?.siteRole ?? 'owner'
  const permissions = auth.user?.permissions
  const accountItems: Array<{
    label: string
    icon: string
    to: string
    disabled?: boolean
  }> = [
    {
      label: 'تنظیمات حساب',
      icon: 'i-lucide-settings',
      to: (role === 'secretary' || role === 'doctor')
        ? '/dashboard/settings'
        : '/dashboard/practice#account',
      disabled: !auth.hasActiveSubscription,
    },
  ]

  if (isDashboardPathAllowed(role, '/dashboard/subscription', permissions)) {
    accountItems.push({
      label: 'اشتراک',
      icon: 'i-lucide-credit-card',
      to: '/dashboard/subscription',
    })
  }
  if (isDashboardPathAllowed(role, '/dashboard/tickets', permissions)) {
    accountItems.push({
      label: 'تیکت‌های پشتیبانی',
      icon: 'i-lucide-life-buoy',
      to: '/dashboard/tickets',
    })
  }

  return [
    accountItems,
    [
      {
        label: 'خروج',
        icon: 'i-lucide-log-out',
        color: 'error' as const,
        onSelect: async () => {
          auth.logout()
          await navigateTo('/auth/login')
        },
      },
    ],
  ]
})
</script>
